import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.index-of.js";
import { passportUrl } from '@/drip/config/domain';
export function handleCheckUserSession(recvData) {
  var success = recvData.success,
    code = recvData.code;
  if (success && code === 0) {
    // 华为账号登录状态有变化
    try {
      localStorage.removeItem('_token');
      var locationUrl = new URL(window.location.href);
      var redirectURL = locationUrl.toString();
      // 跳转登录页面
      var url = "".concat(passportUrl, "/bankLogin?appName=hwfastapp&redirectURL=").concat(encodeURIComponent(redirectURL));
      if (location.hostname.indexOf('maoyan') >= 0) {
        location.href = url;
      }
    } catch (err) {}
  }
}